import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {ImagePatternSingleFillModel} from '../../../../../models/questions/subModels/imagePatternSingleFill.model';
import {NumberPatternSingleFillModel} from '../../../../../models/questions/subModels/numberPatternSingleFill.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-number-pattern-single-fill',
  templateUrl: './evo-number-pattern-single-fill.component.html',
  styleUrls: ['./evo-number-pattern-single-fill.component.css']
})
export class EvoNumberPatternSingleFillComponent implements OnInit {

  Enums = Enums;
  @Input() question: QuestionModel = new NumberPatternSingleFillModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): NumberPatternSingleFillModel {

    return <NumberPatternSingleFillModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question.subCategory === Enums.QuestionSubcategories.numberPatternSingleFill) {
      return true;
    }

    return false;
  }

  questionString(): string {

    return `(${this.castedQuestion().model.firstRange.getRange()}) ${this.castedQuestion().model.patternOpType} (${this.castedQuestion().model.patternValue.getRange()}) * ${this.castedQuestion().model.numPatternValues}`;

  }

}
